/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/packs and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import Rails from "@rails/ujs"
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import 'simplebar'
import 'simplebar/dist/simplebar.css'
import '../controllers'
import '@hotwired/turbo-rails'

Rails.start()
Rails.href = (element) => element.dataset.href || element.href;
Turbo.session.drive = false
Turbo.navigator.history.stop()

window.yaInit = function (...args) {
  const event = document.createEvent('Events')
  event.initEvent('yandex-map-callback', true, true)
  event.args = args
  window.dispatchEvent(event)
}

window.recaptchaInit = function() {
  const event = document.createEvent('Events')
  event.initEvent('recaptcha-callback', true, true)
  window.dispatchEvent(event)
}

window.calltouchEvent = function(events) {
  console.log(events);
  if (events[0].action == 'create' && events[0].data.widgetType == 'promotion') {
    ym(21334294,'reachGoal','Calltouch Widget')
  }
}

window.sendCalltouchForm = function(calltouchKey, obj) {
  if (!calltouchKey) { return; }

  new Promise(function(resolve, reject) {
    try {
      window.ctw.getRouteKeyData(calltouchKey, function(success, data) {
        console.log(success, data);
        if (success) {
          if (data.widgetFound) {
            resolve('виджет найден');
          } else {
            reject('не найден включенный виджет по routeKey, либо услуга обратного звонка не активна');
          }
        } else {
          reject('во время обработки прозошла ошибка');
        }
      })
    } catch (e) {
      reject('calltouch не работает');
    }
  }).then(function(message) {
    console.log(message);

    return new Promise(function(resolve, reject) {
      if (obj.phone) {
        try {
          window.ctw.createRequest(calltouchKey, obj.phone, obj.info, function(success, data) {
            console.log(success, data);

            if (success) {
              resolve('Создана заявка на колбек, идентификатор: ' + data.callbackRequestId);
            } else {
              reject('Во время выполнения запроса произошла ошибка: ' + data.type);
            }
          })
        } catch (e) {
          reject('calltouch не работает');
        }
      } else {
        reject('Нет номера телефона');
      }
    })
  }).then(function(message) {
    console.log(message);
    ym(21334294,'reachGoal','Calltouch Order Form');
    ym(21334294,'firstPartyParams', {
      'email': obj.email,
      'phone_number': obj.phone,
      'first_name': obj.first_name,
      'last_name': obj.last_name,
      "home_address": {
        "city": obj.city,
        "country": 'россия'
      }
    })
  })
  .catch(function(message) { console.log(message); })
}

import '../vue/components/CatalogPrices/catalog_prices'
import '../vue/components/Articles/RelatedArticles/related_articles'
import '../vue/components/Articles/ArticleIndex/article_index'